<section class="section-white" *ngIf="featureData">
  <div class="section-container-inside">
    <div class="product-blog-container-single">
      <div class="product-blog-row">
        <!------- Non-profit pledge to NGOs ------->
        <div class="product-blog orange-100 padd-48">
          <div>
            <div class="product-blog-heading mar-b-16">
              {{ featureData.header }}
            </div>
            <div
              class="product-blog-description"
              [innerHtml]="featureData?.paragraph | toHtml"
            ></div>
          </div>
        </div>
        <!------- Build trust with donors ------->
        <div class="image-product-blog justfy-c-e display-f">
          <img
            src="{{ featureData.image.url }}"
            alt="{{ featureData.image.alt }}"
          />
        </div>
      </div>
    </div>
  </div>
</section>
